var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f0f;opacity:0;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 96,
    height: 96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.45,73.33A31.69,31.69,0,0,0,48,80a32,32,0,0,0,0-64,31.69,31.69,0,0,0-19.55,6.67,4,4,0,0,1-4.9-6.33A39.61,39.61,0,0,1,48,8a40,40,0,0,1,0,80,39.61,39.61,0,0,1-24.45-8.34,4,4,0,0,1,4.9-6.33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8,43l-13-12a4,4,0,0,0-5.44,5.87l7.77,7.14H12a4,4,0,1,0,0,8H51l-7.64,7a4,4,0,0,0,5.44,5.86l13-12a6.69,6.69,0,0,0,0-9.92Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignIn);
export default __webpack_public_path__ + "static/media/sign-in.db5b531c09cc68bec928c855894bbf09.svg";
export { ForwardRef as ReactComponent };